import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@lohi/environments/environment';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { shareReplay, throttleTime } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class InternalService {
  private isInternal$$ = new BehaviorSubject<boolean>(false);
  private isInternalThrottle$$ = new Subject();
  private isInternalsShared$ = this.isInternal$$.pipe(shareReplay(1));

  public get isInternal$(): Observable<boolean> {
    this.isInternalThrottle$$.next();
    return this.isInternalsShared$;
  }

  constructor(private httpClient: HttpClient) {
    this.isInternalThrottle$$.pipe(throttleTime(1000)).subscribe(() => {
      this.loadIsInternal();
    });
  }

  private loadIsInternal() {
    this.httpClient.get<{ internal: boolean }>(`${environment.api}/v1/internal/is_internal`).subscribe((resp) => {
      this.isInternal$$.next(resp.internal);
    });
  }
}
